import React from 'react';
import heroCtaArrowUrl from './assets/hero-cta-arrow.svg';
import StoreDownloadLink from './StoreDownloadLink';
import { useHomeRedesignStrings } from './useHomeRedesignStrings';

/** Figma 3234:14134 — pill bar: title + nested Download CTA */
const HomeRedesignFloatingCtaBar: React.FC<{ linkTabIndex: number }> = ({ linkTabIndex }) => {
  const s = useHomeRedesignStrings();

  return (
    <div
      className="flex w-full max-w-md items-center justify-between rounded-[99px] border border-[rgba(74,33,71,0.1)] bg-[rgba(255,255,255,0.85)] py-[7px] pl-[19px] pr-[7px] shadow-[0px_12px_30px_0px_rgba(74,33,71,0.12)] backdrop-blur-[7px]"
      data-node-id="3234:14134"
    >
      <div className="min-w-0 shrink pr-2">
        <p className="truncate font-jakarta text-[14px] font-bold leading-normal text-[#2a0f2a]">
          {s.hero.floatingBarTitle}
        </p>
      </div>
      <StoreDownloadLink
        popoverPlacement="above"
        tabIndex={linkTabIndex}
        className="inline-flex h-9 shrink-0 items-center justify-center gap-[6px] rounded-[99px] bg-chisme-primary px-4 py-2.5 font-jakarta text-[13px] font-bold leading-normal text-white"
        data-node-id="3234:14137"
      >
        <span className="whitespace-nowrap">{s.nav.openApp}</span>
        <img
          src={heroCtaArrowUrl}
          alt=""
          className="size-[14px] shrink-0"
          aria-hidden
        />
      </StoreDownloadLink>
    </div>
  );
};

export default HomeRedesignFloatingCtaBar;
